import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/weather',
    name: 'Home',
    component: () => import('@/views/Gaode')
  },
  {
    path: '/hefeng',
    name: 'Hefeng',
    component: () => import('@/views/Hefeng')
  },
  {
    path: '/gaode',
    name: 'Gaode',
    component: () => import('@/views/Gaode')
  },
  {
    path: '/caiyun',
    name: 'Caiyun',
    component: () => import('@/views/Caiyun')
  },
  {
    path: '/news-detail',
    name: 'News-Detail',
    component: () => import('@/views/NewsDetail')
  },
  {
    path: '/call',
    name: 'Call',
    component: () => import('@/views/deeplink/Call')
  },
  {
    path: '/course',
    name: 'Course',
    component: () => import('@/views/deeplink/Course')
  },
  {
    path: '/address',
    name: 'Address',
    component: () => import('@/views/address/Address')
  },
  {
    path: '/learning/netcourse',
    name: 'NetCourse',
    component: () => import('@/views/learning/NetCourse')
  },
  {
    path: '/agreement/kjt',
    name: 'AgreeMentKJT',
    component: () => import('@/views/agreement/KJT')
  },
  {
    path: '/agreement/zhongbao',
    name: 'AgreeMentZB',
    component: () => import('@/views/agreement/ZhongBao')
  },
  {
    path: '/agreement/website',
    name: 'AgreeMentWebsite',
    component: () => import('@/views/agreement/Website')
  },
  {
    path: '/agreement/closeaccount',
    name: 'AgreeMentCloseAccount',
    component: () => import('@/views/agreement/CloseAccount')
  },
  {
    path: '/agreement/share',
    name: 'AgreeMentShare',
    component: () => import('@/views/agreement/Share')
  },
  {
    path: '/agreement/privacy',
    name: 'AgreeMentPrivacy',
    component: () => import('@/views/agreement/Privacy')
  },
  {
    path: '/agreement/facerecognition',
    name: 'AgreeMentFaceRecognition',
    component: () => import('@/views/agreement/FaceRecognition')
  },
  {
    path: '/agreement/user',
    name: 'AgreeMentUser',
    component: () => import('@/views/agreement/User')
  },
  {
    path: '/address/update',
    name: 'UpdateAddress',
    component: () => import('@/views/address/UpdateAddress'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/address/choose',
    name: 'ChooseAddress',
    component: () => import('@/views/address/ChooseAddress')
  },
  {
    path: '/doc/iwms',
    name: 'DocIWMS',
    component: () => import('@/views/doc/IWMS')
  },
  {
    path: '/agreement/face',
    name: 'AgreeMentFace',
    component: () => import('@/views/agreement/Face')
  },
  {
    path: '/app/download',
    name: 'Download',
    component: () => import('@/views/app/Download')
  },
  {
    path: '/aliVerify',
    name: 'AliVerify',
    component: () => import('@/views/verify/AliVerify')
  },
  {
    path: '/baseInfoConf',
    name: 'BaseInfoConf',
    component: () => import('@/views/base/BaseInfoConf')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
